import React__default from 'react';
import classNames from 'classnames';
import Styles from './Badge.module.scss.js';
import { BadgeTypes } from '../../constants/misc.js';

const Badge = ({ text, type = BadgeTypes.DEFAULT, outLined = false, squaredEdges = false, isClickable = false, badgeClass, onClick, id = "" }) => {
    const returnStyleClassName = () => {
        if (type === BadgeTypes.ACTIVE)
            return "active";
        else if (type === BadgeTypes.PROGRESS)
            return "progress";
        else if (type === BadgeTypes.WARNING)
            return "warning";
        else if (type === BadgeTypes.PUBLISHED)
            return "published";
        else
            return "";
    };
    return (React__default.createElement("div", { id: id, className: classNames(Styles.badge, Styles[returnStyleClassName()], outLined && Styles.outLined, squaredEdges && Styles.squaredEdges, isClickable && Styles.clickable, badgeClass), onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick() }, text));
};

export { Badge as default };
//# sourceMappingURL=Badge.js.map
